export const orderServices = (arr) => {
  return arr.sort((a, b) => a.orders - b.orders);
}

export const removeActive = () => {
  const activeElem = document.querySelectorAll(`.drop`);
  for (let i = 0; i < activeElem.length; i++) {
    activeElem[i].classList.remove('active');
  }
}

export const unique = (arr, value) => {
  return arr.reduce((o, i) => {
    if (!o.find(v => v[value] === i[value])) {
      o.push(i);
    }
    return o;
  }, []);
}

export const sortDataLabel = (arr) => {
  return arr.sort(function (a, b) {
    return a.label.localeCompare(b.label)
  })
}

export const filterData = (arr) => {
  return arr.filter((element) => {
    return element.name !== 'невідомо' && element.name !== '';
  })
}

export const formatUTC = (strDate, dateOptions, timeOptions) => {
  const date = new Date(strDate);
  const datetoUTC = date.toLocaleDateString('uk-UA', dateOptions);
  if (timeOptions) {
    const timetoUTC = date.toLocaleTimeString('uk-UA', timeOptions);
    return `${datetoUTC} ${timetoUTC}`;
  }
  return datetoUTC;
}

export const setCookie = (name, value, days) => {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (JSON.stringify(value) || "") + expires + "; path=/";
}

export const getCookie = (name) => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    try {
      if (c.indexOf(nameEQ) === 0) return JSON.parse(c.substring(nameEQ.length, c.length));
    } catch (e) {
      // cookie value string
    }
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

export const eraseCookie = (name) => {
  document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}